/*
 * UTILIZARE
 * template("adr/scr/new_project",{into:MAIN,clear:1,record:1,action:2,alfa:1.....}).then();
 * template({interface:"adr/scr/new_project",into:MAIN,clear:1,record:1,action:2,alfa:1.....}).then();
 * MAIN.tpl({interface:"...",record:1});
 */
window.edit_surface = null;
function template(a, b) {
    var CH = new Chain();
    var POST, template_name;
    // normalize input
    if (b === undefined) {
        if (typeof a === "string") {
            template_name = a;
            POST = { interface: a };
        } else {
            // object
            POST = a;
            template_name = a.interface;
        }
    } else {
        POST = b || {};
        template_name = POST.interface = a;
    }

    var ajax_options = {};
    if (POST.hasOwnProperty("opt")) {
        ajax_options = POST.opt;
        delete POST.opt;
    }
    var xdata = {}; // cross-data -- tranfer de date intre interfetze -- client side only  -- nu le las in POST pt ca pot fi non-serializable
    if (POST.hasOwnProperty("xdata")) {
        xdata = POST.xdata;
        delete POST.xdata;
    }
    fail = POST.fail;
    delete POST.fail;

    !POST.child && session.verbose && console.log(POST); // session.verbose

    ask(
        "template.compose",  //  calls  /aha/php/class.template.php ::compose  with $_POST 
        POST,
         /* done */ function ok(...arr) {// text,code,xhr
            let xhr = arr[2];
            var ot = new template_object(template_name, xhr); // template-ul configurat

            // aduc module js necesare --  specificate in componenta json a template-ului  --  ot.conf.require
            ot.modules = {};
            (ot.conf.require || {}).scan(async (k, v) => {
                var M = await ot.require(v);
                ot.modules[k] = M;
                (M.default ?? M.init ?? nf).bind(ot)(ot);
            });

            Promise.all([]).then(
                async () => {
                    await ot.resolve_tdf_alteration();  //  componenta  .tdf a template-ului // !!!BAC>>>  pt x-form  inca nu am tdf aici asa ca folosesc TE.lasy(()=>{ ... })
                    ot.satisfy_options(POST.tail({ xdata }));
                    CH.resolve(ot);
                },
                (error) => {// catch
                    dn(`<table><tr><td><sad></sad></td><td><div hsp2>${error.stack}"</div></td></tr></table><br/>[${ot.name}.json].<m style='color:#bdf'>require</m>`,
                        "ERROR - ES6 MODULES"
                    );
                    CH.reject(error.stack)
                }
            );
        },
        /* fail */ function error(str, silent) {
            !silent && (fail || dn)(str, "ERROR");
        },
        ajax_options // ex {loader:'circle'}
    );
    return CH;
}




// TEMPLATE_OBJECT
function template_object(template_name, req = new XMLHttpRequest) { // aici req este XMLHttpRequest 
    var ot = this;
    ot.name = template_name;
    ot.ffp = ot.project = (+req.header("project") || null); // !!!BAC>>>  apache transforma  NULL in 0   --- deci o sa am TE.ffp === 0 cand nu am template cu proiect 
    ot.PUI = +req.header("PUI") || null;
    ot.action = parseInt(req.header("action"));
    ot.request = parseInt(req.header("request"));
    ot.tgdb = req.header("tgdb") ?? location.host; // posibil alien_acces (date de pe alt site pt proiectul curent)
    ot.alien_access = ot.tgdb !== location.host;
    ot.route = req.header("route") || '';
    ot.redirect = req.header("redirect");
    ot.version = req.header("version");
    ot.grant = req.header("grant");
    ot.fake_task_key = req.header("fake_task_key");
    ot.exception = req.header("exception"); // serverul dicteaza exceptia

    ot.conf = req.header("conf", "parsed") || {}; // continutul componentei json a templatului
    !ot.conf.rules && (ot.conf.rules = {});
    if (ot.conf.xdoc) {
        !ot.conf.hasOwnProperty("test_insert") && (ot.conf.test_insert = []);
        for (let [k, v] of Object.entries(ot.conf.xdoc)) {
            v && v.test_insert && ot.conf.test_insert.push(k);
        }
    }

    var split_response = req.response.split(/<<controller.*?>>/gims); // [view,controler,data,uncomited_stack]


    // VIEW
    // pt alien_access am nevoie de adaptare URI pt toate tagurile de tip script, link, img, object, embed  etc
    var URI = /^http[s]:*/,
        target_host = "https://" + ot.tgdb;  // tgdb poate fi localhost sau dedus dupa  registrar ex PUI=1 
    ot.view = split_response[0].replace(
        /(?<tag><.*?)(?<word>(href|src))=['"\s]*(?<addr>[^\s'"]*)['"\s]*(?<more>[^>]*)>/gim,
        (...A) => {
            let P = A.pop();
            //console.log(P);
            return URI.test(P.addr)
                ? A[0]  //  adresare explicita fara posibilitatea de routare 
                : P.tag + P.word + "=" + target_host + (/^\//.test(P.addr) ? "" : "/") + P.addr + " " + P.more + ">";  // routare prin URI   ex: https://play.myadr.ro/css/path/file.css
        }
    );

    // CSS
    if (req.header("css")) {
        //-- vine cu uri   din template::compose
        ot.css = "<link rel='stylesheet' href='" + req.header("css") + "' />";
    }

    // JS -- !!!BAC>>> a se folosi numai varianta cu positional arguments Q.modules("mdl1","path.mdl2") adica NU NU NU array Q.modules(["mdl1","mdl2"])
    ot.js = split_response[1]
        ? new AsyncFunction(`/*  ${ot.route}/tpl/${ot.name}.js */ ` +
            `var _i=arguments[0], TE=_i.template, _wz_=_i.find("[_wz_]",1);`
            +
            split_response[1].replace(/Q.modules\((.*?)\)/gim, (...A) => {
                var F = A[1]
                    .split(",")
                    .map((s) => s.trim().replace(/()^['"]|['"]$/g, ""))
                    .map((str) => ot.fix_modules_uri(str));
                return 'Q.modules("' + F.join('","') + '")';  // no ; 
            })
        )
        : nf;

    ot.ext = {};

    ot.decimals = {};

    ot.tdf = req.header("tdf", 1) || {}; // tdf(table_definition) structura json_db a datelor citite template_name.json
    // AICI AS MAI PUTEAM modifica comportamentul campurilor in funtie de ceva  --- mai tarziu e dificil
    // adica  o.tdf.c_name trebuie sa fie alceva

    // tdf_override  ---  renunt --- si pun componenta js a interfetei
    ot.tdf_alteration = req.header("tdf_alteration") || null

    ot.columns = (function () {
        var o = {};
        for (var v in ot.tdf) {
            Lister.ready[v] = {}; // REQUIRED -- memoreaza listele de autocomplete cu {"mns":0} minimum search
            o[v] = ot.tdf[v].pkeys();
            let tb = ot.tdf[v];
            for (let j in tb) {
                let cdf = tb[j];
                if (cdf.cmt.ref) {
                    cdf.ref = cdf.cmt.ref; // fortez suprascriere de ref din cmt peste fk-nativ din sql
                }
                if (cdf.cmt.required) {
                    cdf.req = cdf.cmt.required; // fortez suprascriere de required
                }
            }
        }
        return o;
    })();

    Promise.resolve().then(async () => {
        if (!window.info) return;
        ot.req_types = await window.info.req_types;
    });



    /* 
    date citite prin directiva XDOC
    ot.data = req.header('data', 1) || [];  // am mutat in response  pt ca mureau headerele la date multe
    se conserva pseudo-valoarea null din database  -- deci '' sau 0 sunt valori_db nu null
    */
    ot.data = (split_response[2] || "[]").parsed;


    ot.memorize = req.header("memorize", 1) || null;

    ot.zero_data_required = req.header("zero_data_required", 1) || null;

    try {
        ot.uncomited_stack = /^\[/.test(split_response[3]) ? split_response[3].parsed : null; // nu pe headere

    } catch (error) {
        ot.uncomited_stack = null;
        dn("<sad></sad> <span bc style='font-size:1.3em'>MEMORIZED-DATA IS NOT-PARSABLE</span> " + "<h5 vsp1>call <m lc>IT</m></h5>" + "<hr/>" + split_response[3], "ERROR - UNCOMITED_STACK");
        console.log("UNCOMITED_STACK", error, split_response[3])
    }


    // EXTRA_DATA
    ot.extra_data = (split_response[4] || '{}').parsed;

    ot.colected_fkid_hints = req.header("colected_fkid_hints", 1) || {};

    ot.inputs_to_remap = [];  // se incarca din Q.gnr_input();

    ot.composed = req.header("composed", 1); // aici vad in client ce a inteles serverul --- modificari de preguri, versionari, path-uri selectate etc



    // pt FOX - TMPORAR // !!!BAC>>>
    ot.fox_anchors = {};
    ot.fox_enum = {};
    ot.fox_q_id_to_anchor = {};
    ot.fox_q_id_to_label = {};


    Object.defineProperty(ot, "neuron", {
        value: new Neuron({ template: ot, tb_name: ot.name }) // cascadarea child_templates and x-form   "completion" EVENT
        , enumerable: true
    });

}

template_object.prototype = {

    require: function (...A) {
        let B = (Array.isArray(A[0]) ? A[0] : A).map((str) =>
            this.fix_modules_uri(str)
        ); // to URI
        return Q.modules(B);
    },





    /*
        kind of ES6 template literals  --  inlocuieste ${prop} din template.view cu valoarea data :

         1) din js in comanda tempate({interface:"...", _$_:{prop1:"value1_pt_prop1_#####" , prop2:value2} ,     })  -- opt._$_

         2) din componenta json a template-ului : {"xdoc":{}, "_$_":{ "caca":"__tgdb__", "prop2":"__value__"},     }  --  ot.conf._$_
            class.template:compose  face preg_replace pt simboluri predefinite 

        <div>${caca}</div>  -->  <div>__tgdb__</div>  -->  <div>play.myadr.ro</div>

        <input value='${prop2}' />   --> <input value='value1_pt_prop1_#####'/>

     */
    tune: function (x = {}) {
        var $ = this,
            N = 0,
            V = $.view, // html_sting 
            rgx,
            rpl = typeof x === "string" ? x.s2o : x;

        rpl.tail($.conf._$_ || {}); // adaug si proprietatile din _S_  pt ca sunt facute special pt tuning

        for (var n in rpl) {
            rgx = new RegExp("\\${" + n + "}", "gims");
            V = V.replace(rgx, rpl[n]);
            N++;
        }
        // clean all S{prop}  pentru care nu am dat tuning value
        return N ? V.replace(/\${.*?}/gim, "") : V;
    },

    render: function (opt = {}) {
        var $ = this, dom = _E("div", this.tune(opt._$_)).first;
        Object.defineProperty(dom, 'scope', {
            get: function () {
                return this.getAttribute('scope');
            },
            set: function (scope) {
                if (scope || scope === 0) {
                    this.setAttribute("scope", scope);
                }
                else {
                    this.removeAttribute('scope')
                }


            }
        })
        return $.rendered = dom;
    },





    /**
     * pune elementul randat si data-filled in target
     * @param {type} opt
     * @returns {template_object}         */
    put: async function (opt = {}) {
        var
            $ = this,
            target = opt.into ? id2elm(opt.into) : _E(); // daca nu am target  pun in fragment si returnez elementul randat in TE._i ca sa pot face ce vreau cu el in continuare,
        var item = $.render(opt).setA({ template_name: $.name });
        $.project && item.setA({ project: $.project })
        item.template = $;

        $.data.grid_a = []; //  !!!BAC>>> force check if there is a grid to complete
        var interface_has_grid = false;

        var data_to_fill = $.data;


        var IS_EDITABLE_XTAB = target.desc(edit_surface) && target.hasA("active") && target.hasA("tabs_panel");
        IS_EDITABLE_XTAB = target.xtab && target.xtab.is_editable_xtab;
        // !!!! mai trebuie ceva pt controlul multilevel x-tabs !!!!

        // FKID_HINTS 
        if (target === edit_surface) { // cel mai de sus template -- resetez 
            if (!session.changes) {
                COLECTED_FKID_HINTS = $.colected_fkid_hints; // resetez -- sa nu se acumuleze ca la vadu lat 
            }
        } else {
            // orice subtemplate sau template in view completeaza fkid 
            $.colected_fkid_hints.scan((tb_name, c_names) => {
                c_names.scan((c_name, ids) => {
                    ids.scan((id, fkid) => {
                        // protejez TE din MAIN la suprasciere cu FKID din view-uri 
                        !COLECTED_FKID_HINTS.pointer([tb_name, c_name, id]) && COLECTED_FKID_HINTS.pointer([tb_name, c_name, id], fkid);
                    });
                });
            });
        }

        if (target === edit_surface || IS_EDITABLE_XTAB) {
            // am nevoie sa stiu ce e instantiat in edit_zone ca sa pot configura aplicatia config_interface_tools(TE);
            // --- templatul instantiat in MAIN poate fi adresat cu variabila globala TE
            // in interface_name.js am variabila locala  var TE=_i.template ---  adica adresez templatul instantei _i
            TE = $;
            !IS_EDITABLE_XTAB && (MT = $);
            //console.log(item)
            OPISIZER = {};
            body.remA("forced_layout");

            // configurarea tool-urilor specifice interfetei - este posibil ca functia sa se cireasca dupa template
            $.config_status_field({ route: TE.route, ...opt, IS_EDITABLE_XTAB });
            opt.action && (session.action = opt.action);
            opt.project && (session.project = opt.project);
            document.documentElement.scrollTop = 0;
            // SS.tmp este o zona nevolatila in care interfetele isi noteaza chestii care rezista la reload
            if (!session.changes) {
                session.tmp = {};
                session.edited_data = null;
                edit_switch.active = false;
            }
            session.outdated = false;

            // SHOW/HIDE EDIT SWITCH
            edit_switch.visible = false;
            if (this.grant === "edit" && $.conf?.xdoc) { // !!!BAC>>>  daca serverul nu aduce nimic din xdoc (macar tdf) atunci grant e false
                edit_switch.visible = 1;
            }

            if (!$.conf?.xdoc) { // !!!BAC>>> -- de urmarit editatrea cu x-tabs
                // nu are rol de editor deci nu foloseste session.changes
                // uneori ramane agatata aplicatia cu session.changes==true si pe o alta interfatza
                if (session.changes) {
                    console.log("ABERATIE SESSION.CHANGES == true pe o interfatza fara xdoc");
                    session.changes = false;
                }
            }
            if (session.changes) {
                if (session.edited_data) {
                    data_to_fill = session.edited_data;
                } else {
                    dn("<sad></sad> EDITED DATA IS LOST;<hr/>PLEASE RELOAD PAGE!", "ERROR");
                    session.changes = false;
                }
            }

            // RECORND ajax navigation record
            if (Q.bool(opt.record)) {
                var o = { mode: "tpl" }; // vital la reload
                for (var p in opt) {
                    if (p !== "record" && p !== "into") {
                        o[p] = opt[p];
                    }
                }
                o.tail({
                    version: $.version,
                    route: $.route,
                    // PUI: $.PUI,   !!!BAC>>> NU (parametrul PUI lanseaza mecanismul de determinare a registrarului si nu e nevoie pt native_access)
                    project: $.project, // daca accesez numai cu PUI  serverul intoarce p_id
                    tgdb: $.tgdb,
                });
                $.fake_task_key && (o.fake_task_key = $.fake_task_key);
                history.record(o);
            }
            $._i = item;
        }




        // fill
        for (var tb_name in data_to_fill) {
            var D = data_to_fill[tb_name],
                C = $.columns[tb_name];
            var elf = Q("[xdoc~=" + tb_name.esc_css_selector + "]", item); // toate elementele cu attribut xdoc pt care am date ///
            for (let k = 0; k < elf.length; k++) {
                let i = elf[k];
                switch (i.tagName) {
                    case "FORM":
                        // FORM_DATA
                        /**
                         *  formele goale nu vor functiona la update pt ca nu se vor regasi in TE.data si implicit vor lipsi din session.edited_data
                         *  fac aici un artificiu de creare a setului de date 0 ca sa pot permite session.stack undo redo
                         *  in session.save  fac conversie din update in insert pe tabela
                         */
                        D = D[0];
                        var virtual_data = [].fill_new(null, C.length); // BAC??? am pus null  in loc de '' in fill_new
                        virtual_data[0] = "__" + tb_name + Date.now();
                        if (C[1] === "p_id") {  // adica p_id are mereu col_idx = 1 !? 
                            virtual_data[1] = $.project;
                        }
                        if (!D) {
                            D = virtual_data;
                            $.data[tb_name] = [D]; // date fictive si in template.data[tb_name] pt form new  ca sa reziste la reload
                        } else if (!$.data[tb_name].length) {
                            $.data[tb_name][0] = virtual_data;
                        }
                        i.setA("onsubmit", "return false");
                        new form_data(D, tb_name, $, i);
                        break;
                    case "TABLE": // TABULAR_DATA
                        var t = new tabular_data(D, tb_name, $, i);
                        if (i.hasA("slave")) t.panel.setA("slave");
                        t.panel.oust(i);
                        break;
                    case "X-FORM":
                    case "X-GRID-EDITOR": // editor de grile 
                    case "X-DOSSIER": // dosare visttuale  DMS 
                        setTimeout(
                            function () {
                                i.config($); // do not await 
                            },
                            0 // acest defer face sa mearga si pe iPAD -- nu mai mult
                        );

                        break;
                    case "X-GRID":
                        if (!window.x_grid_tdfs) {
                            // aduc o singura data tdf-urile necesare pt grile si le memeorez global 
                            await ask("db\\read_ext\\x_grid_data.get_grid_tdfs").then(r => {
                                window.x_grid_tdfs = r.parsed;
                            });
                        }
                        if (!$.tdf.grid_q) {
                            let R = window.x_grid_tdfs;
                            for (var tb in R) {
                                $.tdf[tb] = R[tb]; // tdf to template
                                $.columns[tb] = Object.keys(R[tb]); // inherit in TE.columns
                                Lister.ready[tb] = {}; // pt asistarea cu hinted list daca e cazul 
                            }
                        }
                        setTimeout(
                            function () {
                                i.config($);
                            },
                            0 // acest defer face sa mearga si pe iPAD -- nu mai mult
                        );
                        interface_has_grid = true;
                        break;

                    case "FOX": // FORM EXTENDED (multy-line-form)
                        //break;
                        /**
                         * ATENTIE IMPUNE OPIS INDEXAT => EXCLUDE OPIS WRAP
                         */
                        if (!$.fox_anchors) {
                            $.fox_anchors = {};
                        }
                        if (!$.fox_anchors.hasOwnProperty(tb_name)) {
                            $.parse_fox_data(tb_name);
                            !session.changes && (D = $.data[tb_name]);
                        }
                        new fox_data(D, tb_name, $, i);
                        break;


                }
            }

        }

        if (!interface_has_grid) {
            delete $.data.grid_a; //  ma deruteaza daca nu sterg urma 
        }

        // CLEAN curatarea zonei in care se face instantierea
        Q.bool(opt.clear) && (target.html = "");






        // orice template xdoc se instantiaza cu inputuri disabled -- exceptie daca vin cu reload si session.changes in MAIN
        ((!session.changes && $.data) || $.parent !== edit_surface) &&
            (item.editable = 0); // see EP.editable



        target._(item);
        $.css && item._(_E($.css));
        // rezolve all special attributes found --- child_template---
        item.init(); // !!!! ATENTIE this is binded to item adica in <span _v_='this.template.ffp'></span>  this e wrapperul obligatoriu din rendered[0]
        // run all inline included script tags
        item.run();

        //  REMAP INPUTS
        $.neuron.on.completion = async function () {  // vezi   Neuron.prototype.check_completion
            $.refine_tdf();
            await Q.AST.lister.remap_inputs($); //   TE.inputs_to_remap e populat  din Q.gnr_input(); -- !!! NU INAINTE DE COMPLETION
            item.fire("completion");
            wait(10).then(() => item.fire("lasy"));
            //console.log($.neuron, "COMPLETION");
            setTimeout(async () => {
                item.resize_inner_textareas_height();
                if ($._lasy_?.length) {
                    $._lasy_.map(fn => {
                        fn.bind($)($);
                    });
                }
            }, 0);
        };

        // into = MAIN
        if (target === edit_surface || IS_EDITABLE_XTAB) { // numai daca 

            // ma juta sa execut TE.on_leave --  exemplu curat sessionStorage de date temporare
            item._(_E("x-leave"));

            // asistarea inputurilor cu widgeturi by type
            !IS_EDITABLE_XTAB && (Q.AST.surface = item); // nu trebuie dubla asistare -- multiple fire
            // dupa ce s-a instatiat tot pina la ultimul child_template fac rezolvarea hinted_lists -- traduc id in den

            // modul memorize schimba continutul butonului de SAVE in MEM din css
            if (TE.memorize) {
                all_menu_buttons.setA("memorize");
                task_btn.setA("hidden");
                item.setA("memorize");
            } else {
                all_menu_buttons.remA("memorize");
                all_menu_buttons.remA("commit");
                task_btn.remA("hidden");
                item.remA("memorize");
            }

            // daca vin din reload sau navigare nepermisa reactivez editarea
            if (session.changes) {
                edit_switch.active = 1;
            }

            // refacerea valorilor din campuri daca am editare tip MEMORIZE si nu SUNT IN EDIT_MODE pt ca atunci ia date din  session.edited_data si se refac automat
            if (TE.memorize && !session.changes) {
                var H = history.now;
                $.neuron.on.completion = async function () { // overite  $.neuron.on.completion above
                    $.refine_tdf();
                    await Q.AST.lister.remap_inputs($); // trebuie sa astept remaparea pt ca poate am editat un camp care este remapat -- fac redo dupa care vine remap si modifica -- gresit
                    session.redo_uncomited_changes().then(async function () {
                        if (H.commit) {
                            // pregatesc interfatza cu memorized_data pt commit
                            all_menu_buttons.setA("commit");
                            item.setA("commit");
                            //edit_switch.active=1;
                            TE.commit = true;
                            TE.force_save = true; //  chiar daca am stack gol fac salvarea --- stack gol inseamna incheierea solucitarii fara nici o modificare
                            TE.post = {
                                commit: 1,
                                ref_tb: H.ref_tb,
                                ref_id: H.ref_id,
                                cmz: H.cmz,
                            };
                            //edit_switch.action(1); // acunde toate butoanele si afiseaza save_btn cu continut  COMMIT -- butonul BACK face reverse
                            save_btn.remA("disabled"); // arat butonul save_btn care va arata COMMIT
                        }
                        setTimeout(async function () {
                            item.fire("completion");
                        }, 0);
                    });
                };
            }
            // ma asigur ca nu se mosteneste nimic dintr-o interfata MEMORIZE in EDIT_NORMAL
            if (!TE.memorize && !session.changes) {
                session.stack = [null];
                session.cursor = 0;
            }
            // configurarea butoanelor de FNZ, CLF etc pe care le suporta interfatza
            config_interface_tools();
        }
        $.xdata = opt.xdata || {}; // cross data -- de la interfatza din care am venit -- pasare de date la nivel client 
        // aplic codul din interface_name.js
        $.js && $.js(item);
        // Q.i_context = null;
        // semnalizez instantierea master_template  ---  !!! nu e valabil pt child_template care inca mai au de venit
        setTimeout(function () {
            item.fire("template_dom_ready");
            if (!$.neuron.length) {
                // daca nu exista sub_template-uri sau x-form care sa-si fi legat propriul neuron de templatul curent
                $.neuron.on.completion();
            }
        }, 0);
        $._i = item; // memoreaza elementul in care s-a facut instantierea templatului 
        return $;
    },
    // aduce doar datele xdoc si refoloseste templatul ready !! atentie ASYNC
    fetch: function (opt) {
        // ?? BUG PT FLIKE-uri
        opt = opt || {};
        var $ = this,
            chain = opt.chain || new Chain(),
            prj = opt.project || session.project,
            post_data = {
                interface: $.name,
                project: opt.project || session.project,
                action: opt.action || null,
            }.tail(opt);
        //opt.xdoc && (post_data.xdoc = opt.xdoc);
        // opt.ref && (post_data.ref = opt.ref);
        ask(
            "template.fetch_data_xdoc",
            post_data,
            function () {
                var req = arguments[2],
                    D = req.header("data", "parsed") || [];
                $.data = D;
                $.ffp = req.header("ffp");
                $.exception = req.header("exception");
                $.action = opt.action;
                $.grant = req.header("grant");
                $.satisfy_options(opt);
                chain.resolve($);
            },
            function (err) {
                dn(err);
                chain.reject(err);
            }
        );
        return chain;
    },
    /**
     *
     * @param {*} opt
     * @returns
     */
    satisfy_options: function (opt = {}) {
        var $ = this;
        if (opt.into === MAIN) {
            // EARLY BIND  -- am nevoie pt reload cu session.changes ;
            TE = $;
        };
        //opt.into && $.render(opt).fill(opt).put(opt);
        opt.into && $.put(opt);
        return this;
    },
    fix_modules_uri: function (str) {
        if (!/^http[s]:*/.test(str)) {   // not uri address
            var target_host = "https://" + this.tgdb; // daca vin cu PUI pot afisha templaturi de pe un alt sub_domeniu din familie
            switch (true) {
                case /^\//.test(str): // standard notation 
                    return target_host + str;
                case /^\.\//.test(str): // relative 
                    return target_host + (this.route ? "/" + this.route : "") + "/tpl/" + this.name.dirname + (str.replace(/^\./, ''));
                default: // dot chrooted to js directory  --- EX : ~.monitor equivalent to /aha/kernel/js/monitor.js
                    let sgm = str.split("."),
                        lib = sgm.shift();
                    if (!["~", "aha"].has(lib)) {
                        sgm.unshift(lib);
                        lib = "";
                    }
                    return target_host + (lib ? "/" + lib : "") + "/js/" + sgm.join("/") + ".js";
            }
        }
        return str;
    },
    // pt child_template - flikeuri pe subiect preiau tdf si date ca sa pot face editarea uniforma in MAIN
    inherit: function (child_tpl, subject) {
        var $ = this;
        ["tdf", "columns"].map(function (prop) {
            var sc = child_tpl[prop],
                tg = $[prop];
            for (var i in sc) {
                tg[i] = sc[i];
            }
        });
        var sc = child_tpl["data"];
        var tg = $["data"];
        if (subject) {
            if (subject === 1) {
                //COMPONENTA
                for (var v in child_tpl.data) {
                    var d = child_tpl.data[v];
                    $.data[v] = d.length === 0 ? {} : d;
                }
            } else {
                // FLIKE
                // tre sa regindesc in funtie de pfkid - altfel se amesteca datele - desi in db sunt unice by id
                // datele se oranizeaza                   tb_name/subject/pfkid/[id,........]
                //
                var pfkid = child_tpl.pfkid || 0;
                for (var i in sc) {
                    tg[i] = tg[i] || {};
                    tg[i][subject] = tg[i][subject] || {};
                    tg[i][subject][pfkid] = sc[i];
                }
            }
        } else {
            // FREE CHILD_TEMPLATE
            for (var i in sc) {
                tg[i] = tg[i] || [];
                sc[i].map(function (row) {
                    tg[i].push(row);
                });
            }
        }
        $.conf.rules.tail(child_tpl.conf.rules);
    },
    refine_tdf: function () {
        this.SSD = {}; //server save directives
        for (var tb in this.tdf) {
            this.SSD[tb] = { c_names: this.columns[tb] };
            var tdf = this.tdf[tb],
                qfs_N = 0,
                qfs_D = [],
                gnr_N = 0,
                gnr_D = [],
                dec_D = {},
                dec_N = 0;

            for (var col in tdf) {
                // REF -- FOREIGN_KEY
                if (0 && tdf[col].cmt.ref) {
                    // !!!BAC>>> fac suprascrierea din server --  e mult mai avantajos si sigur  pt ca folosesc cached cu redis 
                    // console.log("REFINE TDF --- suprascriere REF ", tb, col,)
                    //tdf[col].ref = tdf[col].cmt.ref; // suprascriu foreign_key cu ce am in cdf pt a putea face hinted_list colosind view-uri sql
                }

                // QFS && GNR -- serverul va trebui sa stie sa-si schimbe comportmentul pt anumite tabele
                if (tdf[col].cmt.qfs) {
                    ++qfs_N;
                    qfs_D.push(1);
                } else {
                    qfs_D.push(0);
                }
                if (tdf[col].gnr) {
                    ++gnr_N;
                    gnr_D.push(1);
                } else {
                    gnr_D.push(0);
                }

                if (/decimal/.test(tdf[col].type)) {
                    dec_D[col] = parseInt(tdf[col].type.split(",")[1]);
                    ++dec_N;
                }
                if (tdf[col].cmt.obey) { // foloseste la liste cascadate cu map2 sau hint=[""]
                    let m_column = tdf[col].cmt.obey;
                    let A = tdf[m_column].cmt.resets || [];
                    A.push(col);
                    tdf[m_column].cmt.resets = A.unique();
                    tdf[col].cmt.no_cache = 1 // trebuie citit de fiecare data --- ar trebui sa fac un cache mai destept cu fallback pe remote


                    tdf[col].cmt.dynamic_override = function (inp, ask_data) {
                        let
                            m_inp = inp.logical_sibling(m_column),
                            v = m_inp.cdf.cmt.map2 ? m_inp.real_value : m_inp.value;
                        if (!v) {
                            m_inp.show_error("VALUE NEEDED<hr/>tree selection");
                            return { error: 1 }
                        }
                        var link_tb = inp.cdf.cmt.link_tb; // !!! obey + link_tb
                        if (link_tb) { // !!!BAC>>> se poate face subquery de matrasire link_tb 

                            return { where: `id IN (SELECT ${inp.name} FROM ${link_tb} WHERE ${m_column} = ${v})` }
                        }
                        else {
                            return { where: "ref_id = " + v }
                        }
                    }

                }
            }
            if (qfs_N) {
                this.SSD[tb].qfs = qfs_D;
            }
            if (gnr_N) {
                this.SSD[tb].gnr = gnr_D;
            }
            if (dec_N) {
                this.decimals[tb] = dec_D;
            }
        }
    },
    parse_fox_data: function (tb_name) {
        // normalizarea datelor din associativ in numeric array
        var $ = this;
        //!$.hasOwnProperty("fox_enum") && ($.fox_enum = {});
        // !$.hasOwnProperty("fox_q_id_to_anchor") && ($.fox_q_id_to_anchor = {});
        var NormalizeData = [],
            ANC = ($.fox_anchors[tb_name] = {}),
            ENUM = ($.fox_enum[tb_name] = {}),
            Q2ANC = ($.fox_q_id_to_anchor[tb_name] = {});
        $.data[tb_name].map(function (set, set_ord) {
            var row_data = [].fill_new(null, $.columns[tb_name].length);
            Q2ANC[set.q_id] = set.anchor;
            //ENUM[set_ord] = {}
            $.columns[tb_name].map(function (c_name, ord) {
                if (c_name === "id") {
                    ANC[set_ord] = set.anchor; // memorez la care set de date  se refera numele de anchor
                    //HINTS[set_ord] = set.hint;
                    if (Q.bool(set.valori_posibile)) {
                        var str = set.valori_posibile.replace(
                            /\((.*?)\)/gim,
                            function (x) {
                                return (
                                    "[" +
                                    eval("[].range(" + RegExp.$1 + ")") +
                                    "]"
                                );
                            }
                        );
                        ENUM[set_ord] = str.parsed; // VALORI_POSIBILE in SQL
                    }
                }
                row_data[ord] = set[c_name] || null;
            });
            NormalizeData.push(row_data);
        });
        $.data[tb_name] = NormalizeData;
    },
    col_idx: function (tb_name, col_name) {
        return this.columns[tb_name].indexOf(col_name);
    },
    config_status_field: function (opt) {
        if (!opt.IS_EDITABLE_XTAB) {
            var $ = this,
                detail = opt.ref_tb ? "-- <small>" + opt.ref_tb + ":" + opt.ref_id + "</small> --" : "",
                alien_access = $.tgdb === location.host ? "" : "[" + $.tgdb + "]",

                stf = status_write("<span style='color:#ffa'>TPL</span>" + alien_access + " " +
                    (opt.route ? opt.route + "/" : '') +
                    $.name + ($.version ? " <cmt>" + $.version + "</cmt>" : "") + " </span> " + detail + " |");
            var pp = $.ffp ? ($.PUI ? $.ffp + "/PUI:" + $.PUI : "p_id:" + $.ffp) : '';
            var prj_info = _E("<span title='info proiect' style='cursor:pointer;display:inline-block;padding:0 .5em;background:green'>" + pp + "</span>");
            prj_info.on("click", function () {
                bring_project_info(prj_info.html.split(":")[1]);
            });
            stf._(prj_info, _txt("|"));
            var act_id = parseInt(opt.action || $.action) || "",
                action = _E("<span title='actiune' style='cursor:pointer;display:inline-block;padding:0 .5em;'>" + (act_id) + "</span>");
            action.on("click", function () {
                let act = ACTIONS[this.html],
                    unit = FUS.units[act.unit],
                    dpt = FUS.units[unit.dpt],
                    info = "<br/><div style='font-size:1.2em;white-space:nowrap'><b>unit:</b> " + unit.path + " <m k>[" + unit.id + "]</m>" + "<br/><b>action:</b> " + act.den + "<m k>[" + act.id + "]</m></div><br/>";
                info = [{ unit: unit.path + " <m k>[" + unit.id + "]</m>", action: act.den + "<m k>[" + act.id + "]</m>" }].to_table(0, 1)
                if (act.name) {
                    info += "<div cmt style='margin:.5em 0'>" + act.name + "</div>";
                }
                if (act.expl) {
                    info += "<div cmt style='margin:.5em 0'>" + act.expl + "</div>";
                }

                interface_documentation_btn.shup({ info, time: 4000 })
            });
            stf._(action);
        }
    },
    assoc: function (tb_name) {
        return (edit_switch.active || session.changes) && this == TE && session.edited_data // daca expun date intr-un view in timpul editarii ?!
            ? this.columns[tb_name].combine_to_collection(session.edited_data[tb_name])
            : this.columns[tb_name].combine_to_collection(this.data[tb_name]);
    },




    table_has_gnr: function (tb_name) {
        if (!this._generated_columns.hasOwnProperty(tb_name)) {
            this._generated_columns[tb_name] = [];
            this.columns[tb_name].map((c_name) => {
                !!this.tdf[tb_name][c_name].gnr &&
                    this._generated_columns[tb_name].push(c_name);
            });
            !this._generated_columns[tb_name].length &&
                (this._generated_columns[tb_name] = false);
        }
        return this._generated_columns[tb_name];
    },
    table_gnr_columns: function (tb_name) { // ar trebui asta in loc de table_has_gnr
        let A = [], o = TE.SSD[tb_name];
        o.gnr.map((v, idx) => {
            v && A.push(o.c_names[idx]);
        });
        return A;
    },
    model: function (set) {
        // TODO:
        // template("interface")->[view,data_sets_placeholders=[{},{},{}],controller] -> model = "render for each set "

        return;
        // asta face inlocuirile pt placeholdere si cleaningul pt ce lipseste
        // accepta array of js objects
        var $ = this;
        var view_copy = this.view;
        console.log(view_copy);
        // view-ul este un string --- innerText al viitorului elemnt template
        for (var plh in set) {
            var rpl = set[plh];
            typeof rpl !== 'object' && (rpl = [rpl]);
            /* replacementul poate fi :
             *  string : inlocuire simpla
             *  array of strings : se multiplica elementul ce contine placeholderul si se fac toate substitutiile  <li>{{ }}</li> <option>{{ }}</option> 
             *  array of objects : e vorba de table si se construieste <table> {{ tb_name }} </table>
             */

            // ????????????????????  tre sa mai puric 
            // asta merge doar daca am <tag>{{plh}}</tag>  sau <input value="{{ plh }} "/>
            var rgx = new RegExp("(<[^>]*>)?\\s*{{\\s*(\\b" + plh + "\\b)" + "(?:\\s*\\|?(.*?))?" + "}}\\s*(<\\/[^>]*>)?", "gim");
            if (typeof rpl[0] === 'object') {
                // table
                view_copy = view_copy.replace(rgx, function () {
                    var ret = RegExp.$1
                        , format = RegExp.$3
                        , tail = RegExp.$4
                        , cols = "<tr>"
                        , c_name = [];
                    for (var v in rpl[0]) {
                        cols += "<th>" + v + "</th>";
                        c_name.push(v);
                    }
                    cols += "</tr>";
                    (!format || !format.has('-head')) && (ret += "<thead>" + cols + "</thead>");
                    ret += "<tbody>";
                    rpl.forEach(function (row) {
                        ret += "<tr>";
                        c_name.forEach(function (c) {
                            ret += "<td>" + $.format((row[c] || ''), format) + "</td>";
                        });
                        ret += "</tr>";
                    });
                    ret += "</tbody>";
                    (format && format.has("+foot")) && (ret += "<tfoot>" + cols + "</tfoot>");
                    return ret + tail;
                });
            } else {
                view_copy = view_copy.replace(rgx, function () {
                    // aici se face multiplicarea daca am array si formatarea 
                    return rpl.map(function (item) {
                        var format = RegExp.$3
                            , front = RegExp.$1
                            , tail = RegExp.$4;
                        return (front || '') + $.format(item, format) + (tail || "");
                    }).join('');
                });
            }

        }
        // cleaning all
        view_copy = view_copy.replace(/(<[^>]*>)?\s*{{.*?}}\s*(<\/[^>]*>)?/gim, '');
        var out = _E('div', view_copy);
        return out.first || out;
        // asta impune wrapper obligatoriu in template
    },


    push_reset_fkid_hints() {
        console.log(this.colected_fkid_hints, "ADUCE FKID HINTS");

    }
};

Object.defineProperties(template_object.prototype, {

    _generated_columns: {
        value: {},
    },
    toString: {
        value: function () {
            return "template_object";
        },
    },
    stamp_data: {
        value: function () {
            var o = this.composed;
            ask(
                "template.stamp_data",
                {
                    interface: this.name,
                    p_id: this.ffp,
                    ref_id: o.__ref_id__,
                    args: this.composed,
                    data: TE.data,
                },
                function (r) {
                    dn(r, "NOTIFICARE");
                }
            );
        },
    },

    fullname: {
        get: function () {
            return "/" + (this.route ? this.route + "/" : "") + "tpl/" + this.name + this.version;
        },
    },
    completed: {
        get: function () {
            return !this.neuron.completion.length
        }
    },

    lasy: {
        value: function (...A) {
            if (!this._lasy_) {
                this._lasy_ = [];
            }
            A.map(fn => { this._lasy_.push(fn) });
        }
    }
});

Object.defineProperty(template_object.prototype, "resolve_tdf_alteration", {
    value: async function () {
        let ot = this;
        if (ot.tdf_alteration) { // !!!BAC>>>  header genrated on server if tpl_name.tdf  file detected  
            await ot.require(ot.tdf_alteration).then((M) => {
                (M.default ?? M.init ?? nf).bind(ot)(ot);
                // !!!BAC>>> trebuie sa am continut 
                /* 
                    export default function(ot){  
                         ... this === ot;
                    ex : ot.tdf.tb_name.c_name.cdf.ref = "caca" 
                    } 
                */
                /*
               atentie la x-aim, x-form, x-grid, x-pills si alte elemente care isi iau singure tdf -- trebuie sa faca singure (separat de TE) alterarea daca e cazul 
               - sau -
               in modul folosesc TE.lasy(fn1,fn2,.... ) -- adica determin modificarea  dupa completion
               - sau -
                    while (!condition) {
                        await wait(50);
                    }
                    ... code
                */


            });
        }
    }
});


Object.defineProperty(template_object.prototype, "paint_sql_do", {
    value: async function (_i) {
        ask("template.fetch_memorized_record", { ref_id: this.request, project: this.project, interface: this.name }).then(r => {
            let R = r ? r.parsed : null;
            if (R) {
                if (R.stack) {
                    return // am dt_solve cu uncommited --- ar afisha si stack si sql_do   
                }
                if (R?.sql_do === '[]' || !R?.sql_do) {
                    R.sql_do = []
                }
                R.sql_do.map(stk => {
                    var elm = _i.find(`[xdoc=${stk.table}]`, 1),
                        type = elm.tagName,
                        LR; // logical row 
                    switch (type) {
                        case "FORM":
                            LR = elm;
                            break;
                        case "TABLE":
                            LR = elm.tbody.find("[db_id='1']", 1).closest("[logical_row]");
                            break;
                        case "X-FORM":
                            _i.find(`[xdoc=${stk.table}]`).map(xf => {
                                xf.rows.map(row => {
                                    if (row.hasA("rid", stk.id)) {
                                        LR = row;
                                    }
                                });
                            })
                            break;
                        case "M-FORM":
                        case "FLIKE":
                            console.log("TREBUIE SUPORT")
                            break
                    }
                    switch (stk.act) {
                        case "u":
                            stk.set.scan((c_name, arr) => {
                                LR.find(`[name=${c_name}]`, 1).setA("commited_data")
                            });
                            break;
                        case "i":
                            LR.setA("commited_data")
                            break;
                        default: //"d"  --- cam nasol de afishat
                            //  tre sa gases parintele dupa cascade si ref_id in date 
                            console.log("DELETED", LR, type, stk.table, stk.act, stk)
                            break;
                    }
                })
            }
        })
    }
});

/**
 *  B = await TE.load_budgeter();
 * 
 * chestia asta asigur ca daca am in mai multe locuri code de genul
 *  TE.budgetify().then((BGT)=>{ ... }) care inseamna asigurate ca ai daelede buget dupa care folosestele pentru ...
 *  nu se lanseaza multiple requesturi catre server ci se cupleaza toate promisurile si la citirea bugetului se rezolva toate promisurile  -- cam indigest !!!!
 */

Object.defineProperty(template_object.prototype, "budgetify", {
    value: async function (refresh) {
        if (!this._budgetifyLock && !refresh) {
            this._budgetifyLock = (async () => {
                try {
                    // Refresh or initialize Budgeter
                    if (!this.Budgeter || refresh) {
                        await this.require("/~/js/budgeter.js")
                            .then(M => {
                                this.Budgeter = new M.Budgeter(this);
                            })
                            .then(() => {
                                return this.Budgeter.fetch(); //
                            });
                    }
                    return this.Budgeter;
                } finally {
                    // Release the lock
                    delete this._budgetifyLock;
                }
            })();
        }
        return this._budgetifyLock; // Return the ongoing or completed promise
    },
    enumerable: true
});




Object.defineProperty(template_object.prototype, 'unit', {
    get: function () {
        let unit_id = ACTIONS[this.action]?.unit;
        if (!unit_id) {
            unit_id = 0;
            this.action = 0;
        }
        return FUS.units[unit_id];
    }
});

Object.defineProperty(template_object.prototype, 'amex', { // am-extern
    get: function () {
        let r = FUS.units[this.dpt]?.amex;
        return r === undefined ? r : !!r;
    }
});

Object.defineProperty(template_object.prototype, 'dpt', {
    get: function () {
        return FUS.units[ACTIONS[this.action]?.unit]?.dpt;
    }
});

Object.defineProperty(template_object.prototype, 'dpt_name', {
    get: function () {
        return FUS.dpt_name(this.dpt);
    }
})

Object.defineProperty(template_object.prototype, 'totalized', { // numai pt decimals 
    value: function (tb_name) {
        var $ = this, T = {}; //totals
        $.decimals[tb_name].scan((k, v) => {
            T[k] = 0;
        });
        // valorile din TE.data sau session.edited_data
        $.assoc(tb_name).map(s => {
            T.scan((k, v) => {
                T[k] = Math.sum(v, Q.float0(s[k]))
            });
        });
        return T;
    }
});



bring_project_info = function (p_id, cb) {
    return Q.bool(p_id)
        ? ask("db\\read.project_info", { project: p_id }, true).then(function (r) {
            r = r.parsed;
            for (var v in r.componente) {
                r.componente[v] = r.componente[v].length;
            }
            (cb || Q.i)(r, { title: "project_info p_id = " + p_id });
            return r;
        })
        : new Chain();
};


process_description = function (T/*req_type id */, U /* unit id*/) {
    ask("req_ctrl.process_description", { T, U }, Q.ip);
}

status_write = function (str) {
    if (typeof status_field !== "undefined") {
        status_field.html =
            "<info title='INTERFACE DOCUMENTATION' id='interface_documentation_btn' class='glyphicon glyphicon-info-sign' onclick='get_interface_documentation(event)'></info>" +
            str;
        return status_field;
    }
    return _E();
};


// nu-mi place deloc acest amest de librarie cu schelet  ---  e o porcarie ce fac eu aici si o sa-mi rup botul
config_interface_tools = function (is_get) {
    //console.trace("#! " + arguments.callee.name, [...arguments]);
    var itools = Q("#interface_tools");
    if (is_get) {
        //console.log("GET config");
        // itools.style.display = "none";
    } else {
        if (!window.TE) return;
        edit_btn.remA("disabled"); // in caz ca vin de pe un get interface
        if (TE.exception === 'fnz') {
            edit_btn.setA("disabled"); // nu se permit editari in starea de finalizare -- managerul tocmai ia o decizie
        }
        if (TE.exception) {
            exception_flag.remA("inutil").html = "&nbsp;" + TE.exception.toUpperCase();
            exception_flag.setA("excp", TE.exception);
        } else {
            exception_flag.setA("inutil").html = "";
        }
        try {
            itools.style.display = "block";
            //var buttons = itools.find("[tool_btn]");
            ["clf", "fnz", "pdv"].map(function (str) {
                var btn = itools.find("#" + str + "_tool_btn")[0];
                (history.now.is_task) ? btn.remA("hidden") : btn.setA("hidden"); // in componenta json pun "clf":1,"pdv":0
                (TE.exception === str || !TE.exception) ? btn.remA("disabled") : btn.setA("disabled");  // ex TE.excp ===clf  btn_clf ramane activ ca sa poata retrage clarificarea  
            });
        } catch (err) { }

        setTimeout(function () {
            // configurari specifice unei interfete -- setate in interface.js
            TE.config_interface_tools && TE.config_interface_tools();
        }, 0);
    }
    // Tasker.mark_current_task()
};


// CHILD_TEMPLATE
// INIT pt COMP & FLIKE && no data template
Q.init.defaults.child_template = function (elm) {
    var opt = elm.getA("child_template").s2o,
        parent = elm.closest("[template_name]"), // elementul host
        MT = parent.template.master_template || parent.template, // MASTER_TEMPLATE templatul care va face inherit de child
        PT = parent.template;
    //elm.master_template = MT;
    if (opt.flike) {
        // FLIKE -uri
        var NRN = new Neuron(); // fake neuron --  tine locul neuronului care se va lega pt child_template ca sa nu apara semnal completion fals in PT
        PT.neuron.link(NRN);
        var p_subject = parent.template.subject || null,
            subject = p_subject ? p_subject + "/" + opt.subject : opt.subject,
            parent_flike = elm.closest("[xdoc]"),
            pfkid = parent_flike ? parent_flike.getA("rid") : null;
        elm.limit = parseInt(opt.limit);
        elm.num_flike = 0;
        var title = opt.subject, //.replace("_", " "),
            head = _E("<div fliked_elm_header></div>"),
            add_item = _E("<a add add_flike_item></a>"),
            search_item = _E("<a search></a>");
        elm._(head);
        head._(
            add_item,
            search_item,
            _E("<span fliked_elm_title k>" + title + "</span>")
        );
        add_item.on("click", function () {
            ((elm.num_flike < elm.limit || !elm.limit) &&
                elm.fliker.check_reuse()) ||
                this.shup({ info: "limit " + elm.limit, time: 2 });
        });
        search_item.on("click", function () {
            this.shup({
                info:
                    "TO DO <hr/> cautare " +
                    opt.flike.basename +
                    " pt subiectul " +
                    subject,
            });
        });
        !opt.search && search_item.css("display:none");
        template(opt.flike, {
            project: MT.ffp,
            tgdb: MT.composed.__tgdb__,
            ref: { subject: subject, pfkid: pfkid },
            child: true,
        }).then(function (CT) {
            // CT childTemplate
            PT.neuron.link(CT.neuron); // tirziu
            PT.neuron.unlink(NRN);
            CT.subject = subject;
            CT.pfkid = pfkid;
            MT.inherit(CT, subject);
            CT.master_template = MT;
            CT.parent_template = PT;
            new flike_data(elm, CT).build();
        });
    } else if (opt.comp) {
        // COMPONENTA
        if (!MT.componente_apel || !MT.componente_apel.has(opt.comp)) {
            // console.log("componenta ignorata ", opt.comp);
            return;
        } else {
            // console.log(opt);
        }

        var title = opt.comp.replace("_", " "),
            head = _E("<div comp_elm_header ></div>"),
            add_item = _E("<a add add_comp_item></a>");
        elm._(head);
        head._(
            add_item,
            _E("<span comp_elm_title> COMPONENTE : " + opt.comp + "</span>")
        );
        elm.comp_limit = parseInt(opt.limit) || null;
        add_item.on("click", function () {
            var N = elm.find("comp").length;
            if (elm.comp_limit && N < elm.comp_limit) {
                elm.comp_data.create_new_component();
            } else {
                this.shup({
                    info: "<br/>limitare  " + elm.comp_limit + " componente",
                    time: 2,
                });
            }
        });
        try {
            // REGULA !!!!!!!!!!!!!!!!!!!!  toate componentele se vor plasa in /tpl/comp   !!!!!!!!!!!! REGULA //
            var NRN = new Neuron(); // fake neuron --  tine locul neuronului care se va lega pt child_template ca sa nu apara semnal completion fals in PT
            PT.neuron.link(NRN);
            template("comp/" + opt.comp, {
                project: MT.ffp,
                tgdb: MT.composed.__tgdb__,
                comp: true,
                child: true,
            }).then(function (CT) {
                PT.neuron.link(CT.neuron);
                PT.neuron.unlink(NRN);
                MT.inherit(CT, 1); // -> parent_template enriched
                elm.template = CT;
                CT.master_template = MT;
                CT.parent_template = PT;
                new comp_data(elm, CT).build(); //
            });
        } catch (err) {
            dn(err.getMessage() + elm.tagString, "ERROR : child template");
        }
    } else if (opt.leafer) {
        console.log("LEAFER", elm);
    } else {
        // SIMPLE TEMPLATING NO DB IMPLIED
        opt.into = elm;
        opt.child = true;
        template(opt.interface, opt).then(function (CT) {
            MT.inherit(CT);
        });
    }
};

// ACTIVEAZA sau DEZACTIVEAZA INPUTURI  --- folosesc pt a adauga disable la toate elementele editabile din MAIN --- la enter edit mode devin editabile
Object.defineProperty(EP, "editable", {
    get: function () {
        return this.editable_state;
    },
    set: function (bool) {
        this.setAttribute("hidden", true); // ca sa evit graphic-render pe DOM 
        if (!!bool) {
            if (this.hasA("active_editing")) {
                //console.log("NOTINg TO DO");
            } else {
                this.setA("active_editing");
                this.find(
                    //   "[xdoc]:not([readonly]) input:not([type=button]):not([redonly]),[xdoc]:not([readonly]) textarea:not([readonly]),[xdoc]:not([readonly]) select:not([readonly])," +
                    "[xdoc]:not([readonly]) [name]:not([readonly]):not([type=button]):not([nonsql])"
                ).remA("disabled");
            }
        } else {
            this.remA("active_editing");
            this.find(
                //  "[xdoc] input:not([type=button]):not([nonsql]),[xdoc] textarea:not([nonsql]),[xdoc] select:not([nonsql])," +
                "[xdoc]:not([readonly]) [name]:not([readonly]):not([type=button]):not([nonsql])"
            ).setA("disabled");
        }
        this.removeAttribute("hidden");
    }
});
Object.defineProperty(EP, "paint_sql_do", {
    value: function () {
        var _i = this, tpl = _i.template;
        ask("template.fetch_memorized_record", { ref_id: tpl.request, project: tpl.project, interface: tpl.name }).then(r => {
            let R = r ? r.parsed : null;
            if (R) {
                if (R.stack) {
                    return // am dt_solve cu uncommited --- ar afisha si stack si sql_do   
                }
                if (R?.sql_do === '[]' || !R?.sql_do) {
                    R.sql_do = []
                }
                R.sql_do.map(stk => {
                    var elm = _i.find(`[xdoc=${stk.table}]`, 1),
                        type = elm.tagName,
                        LR; // logical row 
                    switch (type) {
                        case "FORM":
                            LR = elm;
                            break;
                        case "TABLE":
                            LR = elm.tbody.find("[db_id='1']", 1).closest("[logical_row]");
                            break;
                        case "X-FORM":
                            _i.find(`[xdoc=${stk.table}]`).map(xf => {
                                xf.rows.map(row => {
                                    if (row.hasA("rid", stk.id)) {
                                        LR = row;
                                    }
                                });
                            })
                            break;
                        case "M-FORM":
                        case "FLIKE":
                            console.log("TREBUIE SUPORT")
                            break
                    }
                    switch (stk.act) {
                        case "u":
                            stk.set.scan((c_name, arr) => {
                                LR.find(`[name=${c_name}]`, 1).setA("commited_data")
                            });
                            break;
                        case "i":
                            LR.setA("commited_data")
                            break;
                        default: //"d"  --- cam nasol de afishat
                            //  tre sa gases parintele dupa cascade si ref_id in date 
                            console.log("DELETED", LR, type, stk.table, stk.act, stk)
                            break;
                    }
                })
            }
        })
    }
})

window.PRJ_BNF_RL = {}
function prj_bnf_rl(p_id, force_db) {
    if (!+p_id) {
        return Promise.resolve(false);
    }
    if (!force_db) {
        if (session.tmp.prj_bnf_rl) {
            if (session.tmp.prj_bnf_rl.id == p_id) {  // == not === 
                return Promise.resolve(PRJ_BNF_RL[p_id] = session.tmp.prj_bnf_rl);
            }
        }
        if (PRJ_BNF_RL.hasOwnProperty(p_id)) {
            let D = PRJ_BNF_RL[p_id];
            session.edited_data && session.tmp.tail({ prj_bnf_rl: D });
            return Promise.resolve(D);
        }
    }
    return ask(__read__, { tb_name: 'prj_bnf_rl', where: "id = " + p_id, fetch: 5 }).then(r => {
        let D = r.parsed[0];
        if (!D) {
            dn(`<sad></sad> P_ID: <m lc>${p_id}</m> HOT FOUND`, "ERROR")
        }
        session.edited_data && session.tmp.tail({ prj_bnf_rl: D }); //  scutesc o citire la reload page 
        return PRJ_BNF_RL[p_id] = D;
    })

}








// TABURI NOI DESCHISE DIN JS 
template._tab_ = function (tpl_name, POST = {}) {
    var tab_id = POST.tab_id || Date.now().toString(16),
        F = _E("form").setA({
            action: "/~/_tab_.php?tab_id=" + tab_id,
            target: "_blank",
            method: "POST",
            hidden: 1,
        });
    F._(_E("input").setA({ name: "interface", value: tpl_name }));
    F._(_E("input").setA({ name: "from", value: history.now.interface }));
    for (var p in POST) {
        var value =
            typeof POST[p] === "string" ? POST[p] : JSON.stringify(POST[p]);
        F._(_E("input").setA({ name: p, value: value }));
    }
    document.body._(F);
    F.submit();
    F.die(-1);
    return tab_id;
};

// exemplu template._tab_.ping("cucu",{reload:1,cb:'Q.i([tab_id,DATA,TE])',post:{B:1},data:{name:"IO"}})
// reload pt lucru cu serverul
// cb pt js after reload sau direct daca am reload =false
template._tab_.ping = function (tab_id, OBJ = {}) {
    localStorage.update_tab_ = JSON.stringify({ tab_id: tab_id }.tail(OBJ));
};





CROSS_TEMPLATE_DATA = {};

// GO_BACK button ...
goBack = function () {
    if (session.changes) {
        back_btn.shup({ info: '<atentie>ATENTIE  </atentie><hr/> EDITARI NESALVATE<br/><br/> SAVE your work or DISCARD <div style="clear:both"></div>', time: 2 });
    } else {
        var B = history.now.back;
        if (B) {
            CROSS_TEMPLATE_DATA = B;
        } else {
            CROSS_TEMPLATE_DATA = {};
        }

        history.go(-1);
    }
};

window.back_btn && back_btn.on("click", goBack);




put_go_back_btn = function (place, text) {
    console.log(place, "#############")
    var btn = _E("<back_btn btn >" + (text || "go back") + "</back_btn>");
    btn.addEventListener("click", function (ev) {
        goBack(this);
    });
    place && place._(btn);
    return btn;
};
